import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdfb0eec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-upload-custom-list" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "svg-icon svg-icon-3"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "row mt-6"
}
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "d-flex flex-column gap-2" }
const _hoisted_10 = { class: "file-info flex-auto position-relative" }
const _hoisted_11 = { class: "file-name break-all" }
const _hoisted_12 = { class: "file-tools" }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      "file-list": _ctx.formData.fileList,
      "onUpdate:file-list": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.fileList) = $event)),
      name: _ctx.props.name,
      action: _ctx.props.uploadUrl,
      headers: _ctx.uploadHeaders,
      limit: _ctx.props.limit,
      "auto-upload": _ctx.props.autoUpload,
      "show-file-list": false,
      multiple: true,
      accept: _ctx.props.accept,
      data: _ctx.props.data,
      "list-type": _ctx.props.listType,
      "on-exceed": _ctx.handleUploadExceed,
      "on-error": _ctx.handleUploadError,
      "on-progress": _ctx.handleUploading,
      "on-success": _ctx.handleUploadSuccess,
      "on-change": _ctx.handleUploadChange,
      ref: "uploadRef",
      disabled: _ctx.loading || _ctx.disabledClick
    }, {
      trigger: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: _normalizeClass(["btn", _ctx.clickClass]),
          disabled: _ctx.loading || _ctx.disabledClick
        }, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                (_ctx.clickIcon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(_component_inline_svg_icon, { src: _ctx.clickIcon }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.clickToUpload || _ctx.t("common.attachFiles")), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
              ]))
        ], 10, _hoisted_2)), [
          [_directive_auth, { auth: ['update'] }]
        ])
      ]),
      tip: _withCtx(() => [
        _withDirectives(_createElementVNode("div", { class: "el-upload__tip" }, _toDisplayString(_ctx.uploadTip || _ctx.t("common.uploadTip")), 513), [
          [_vShow, _ctx.isShowTip]
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn btn-light-primary me-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeAll && _ctx.removeAll(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.removeAllText || _ctx.t("common.removeAll")), 1)
        ])), [
          [_directive_auth, { auth: ['update'] }],
          [_vShow, _ctx.formData.fileList.length > 0 && _ctx.isShowRemoveAll]
        ])
      ]),
      _: 1
    }, 8, ["file-list", "name", "action", "headers", "limit", "auto-upload", "accept", "data", "list-type", "on-exceed", "on-error", "on-progress", "on-success", "on-change", "disabled"]),
    (_ctx.isShowList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.fileList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "bg-light d-flex align-items-center el-upload-list-custom px-4 py-2 rounded",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.name) + "（" + _toDisplayString(_ctx.bytesToSize(item.size)) + "） ", 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["file-percentage position-absolute top-50 bottom-50 start-0 end-0 translate-middle-y opacity-0", {
                  'opacity-100': item.status === 'uploading',
                }])
                    }, [
                      _createVNode(_component_el_progress, {
                        class: "w-100",
                        percentage: item.percentage
                      }, null, 8, ["percentage"])
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                      default: _withCtx(() => [
                        (_ctx.isShowRemoveAll)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "svg-icon svg-icon-3 cursor-pointer",
                              onClick: ($event: any) => (_ctx.removeItem(item, index))
                            }, [
                              _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/remove.svg" })
                            ], 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}